import { defineStore } from 'pinia';
import { useCache } from '@/hooks/useCache';
import { GetTradeCacheListApi } from '@/apis/basics/trade.api';

const { wsCache } = useCache();
const CacheKey = 'TradeCacheList';

/* 乙方(相对方)数据缓存 */
export const useTrades = defineStore('trade_maps', {
	state: (): any => ({
		tradeList: [] as any[],
		tradeMap: {} as any,
	}),
	getters: {},
	actions: {
		getName(rowid: string) {
			if (!rowid) return '--';
			return this.tradeMap.get(rowid) ?? '--';
		},
		getSelectList() {
			return this.tradeList
				.filter((cus: any) => cus.is_enabled == 'Y')
				.map((cus: any) => {
					return { label: cus.name, value: cus.id };
				});
		},
		async setTradeMap() {
			wsCache.delete(CacheKey);

			let dataList = wsCache.get(CacheKey);
			if (!dataList) {
				dataList = await this.getDataList();
			}
			
			this.tradeList = dataList;

			/* 设置映射 */
			const dataMap = new Map();
			dataList.forEach((item: any) => {
				dataMap.set(item.id, item.name);
			});

			this.tradeMap = dataMap;
		},
		getDataList() {
			return new Promise((resolve) => {			
				GetTradeCacheListApi().then((res: any) => {
					const dataList = res.data || [];
					wsCache.set(CacheKey, dataList);
					resolve(dataList);
				});
			});
		},
	},
});
